import { useEffect, useState } from "react";

export default function NewsletterPopup() {
  const [visible, setVisible] = useState(false);
const [submitted, setSubmitted] = useState(false);
const [email, setEmail] = useState("");
  useEffect(() => {
  const alreadySeen = localStorage.getItem("alkimya_newsletter_seen");

  if (!alreadySeen) {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }
}, []);

  const closePopup = () => {
    localStorage.setItem("alkimya_newsletter_seen", "true");
    setVisible(false);
  };
const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

 try {
  const res = await fetch("https://alkimyaestetica.com/subscribe.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  console.log("STATUS:", res.status);

  const data = await res.json();

if (data.status === "new") {
  localStorage.setItem("alkimya_newsletter_seen", "true");
  setSubmitted(true);

  setTimeout(() => {
    setVisible(false);
  }, 1000);

} else if (data.status === "updated") {
  alert("Sei già iscritto alla nostra newsletter 💛");
  setVisible(false);

} else {
  alert("Errore durante l'iscrizione.");
}
} catch (error) {
  console.log("ERRORE FETCH:", error);
  alert("Errore server.");
}
  }
if (!visible) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div
  className="
    relative
    max-w-md w-full
    rounded-3xl
    p-8
    bg-white/10
    backdrop-blur-2xl
    border border-white/20
    shadow-[0_25px_80px_rgba(0,0,0,0.35)]
    overflow-hidden
    animate-popupEnter
  "
>
        <button
         onClick={closePopup}
  className="absolute top-4 right-4 z-10 text-xl text-white hover:text-white/70 transition-colors"
>
          <div className="absolute inset-0 pointer-events-none">
  <div className="absolute -top-20 -left-20 w-60 h-60 bg-white/20 rounded-full blur-3xl"></div>
  <div className="absolute bottom-0 right-0 w-40 h-40 bg-gradient-to-br from-white/20 to-white/5 rounded-full blur-2xl"></div>
</div>
          ×
        </button>

       <h3 className="text-2xl font-serif mb-4 text-center text-white">
  -10% sul tuo primo trattamento
</h3>

       <p className="text-center text-white/80 mb-6">
  Iscriviti ora e ricevi il tuo codice sconto esclusivo per il primo trattamento da Alkimya Estetica Avanzata.
</p>

        {submitted ? (
  <div className="text-center text-white">
    <h4 className="text-xl font-serif mb-2">
      Codice inviato 🎉
    </h4>
    <p className="text-white/80">
      Controlla la tua email per utilizzare il tuo -10%.
    </p>
  </div>
) : (
  <form onSubmit={handleSubmit} className="flex flex-col gap-4">
    <input
  type="email"
  placeholder="Inserisci la tua email"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  required
  className="w-full px-4 py-3 rounded-xl bg-white/20 backdrop-blur-lg border border-white/30 text-white placeholder-white/70 outline-none"
/>

    <button
      type="submit"
      className="bg-white/20 text-white rounded-full py-3 border border-white/30 hover:bg-white/30 transition-all duration-300"
    >
      Ottieni il -10%
    </button>
  </form>
)}
      </div>
    </div>
  );
}